import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ProductCard from "examples/Cards/ProductCards";

import MongoHandler from "services/mongoHandler";
import TokenFunctions from "functions/tokenFunctions";
import { useNavigate } from 'react-router-dom';

const productTypes = ["honig", "drink", "care", "strength", "other"];

function Warehouse() {
  const [products, setProducts] = React.useState([]);
  const [tabsOrientation, setTabsOrientation] = React.useState("horizontal");
  const [tabValue, setTabValue] = React.useState(0);

  const mongoHandler = new MongoHandler();
  const tokenFunctions = new TokenFunctions();
  const navigate = useNavigate();

  const loadProducts = async (type) => {
    const tempProducts = await mongoHandler.getFilteredProducts(type);
    setProducts(tempProducts);
  };

  React.useEffect(() => {
    loadProducts("honig");
    if (!tokenFunctions.refreshToken()) {
      navigate('/authentication/sign-in/simple');
    }
  }, []);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    loadProducts(productTypes[newValue]);
  };
  const updateProducts = async (body, productIndex) => {
    // Send patch request to update the product in the database
    await mongoHandler.updateProduct(body.productId, body);
    // Update the local state to reflect the change
    setProducts((prevProducts) =>
      prevProducts.map((product, index) =>
        index === productIndex ? body : product
      )
    );
    console.log(`Product ${body.productId} updated successfully.`);
  } 

  const updateProductDisplayed = async (event, newValue, productIndex) => {
    try {
      // Determine the updated display state
      const productDisplayed = newValue === 0;
      // Find the product to update
      const productToUpdate = products[productIndex];
      // Prepare updated product data
      const updatedProduct = { ...productToUpdate, productDisplayed };
      await updateProducts(updatedProduct, productIndex);
    
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const updateAmountAvailable = async (newValue, productIndex) => {
    try {
      // Find the product to update
      const productToUpdate = products[productIndex];
      // Prepare updated product data with the new amount available
      const updatedProduct = { ...productToUpdate, amountAvailable: newValue };
      // Update the product
      await updateProducts(updatedProduct, productIndex);
    
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const updatePrice = async (newValue, productIndex) => {
    try {
      // Find the product to update
      const productToUpdate = products[productIndex];
      // Prepare updated product data with the new amount available
      const updatedProduct = { ...productToUpdate, price: newValue };
      // Update the product
      await updateProducts(updatedProduct, productIndex);
    
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AppBar position="static">
        <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
          <Tab label="Honig" />
          <Tab label="Getränke" />
          <Tab label="Hautpflege" />
          <Tab label="Stärkung" />
          <Tab label="Andere" />
        </Tabs>
      </AppBar>
      <MDBox>
        <Grid container spacing={3}>
          {products.map((item, index) => (
            <Grid key={item.productId} item xs={12} md={6} lg={4}>
              <ProductCard
                product={item}
                index={index}
                updateAmountAvailable={updateAmountAvailable}
                updateProductDisplayed={updateProductDisplayed}
                updatePrice={updatePrice}
              />
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </DashboardLayout>
  )
}

export default Warehouse;
